import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class MTAIcon extends BaseIcon {
  getChildren = () => {
    const color = this.getColor() === 'currentColor' ? '#6568cd' : this.getColor()
    return [
      <path fill={color}
            d="M2,10.82V25.18a3.79,3.79,0,0,0,1.92,3.26l12,7a4.13,4.13,0,0,0,4.16,0l12-7A3.79,3.79,0,0,0,34,25.18V10.82a3.79,3.79,0,0,0-1.92-3.26l-12-7a4.13,4.13,0,0,0-4.16,0l-12,7A3.79,3.79,0,0,0,2,10.82Z"/>,

      <g fill="#ffffff">
        <path d="M26.58,25H9a1,1,0,0,1-1-1L8,11a1,1,0,0,1,1-1H9a1,1,0,0,1,1,1l0,12H26.58a1,1,0,0,1,0,2Z"/>

        <path fill={color}
              d="M28,26h-4a2.05,2.05,0,0,1-2-1.34A2,2,0,0,1,24,22h2l0-6.75-6.66,4.81a2,2,0,0,1-2.41,0L7.8,12.81a2,2,0,1,1,2.44-3.19l8,6.3,8.49-6.13A2,2,0,0,1,30,11.32L30,24a2,2,0,0,1-2,2Z"/>
        <path
          d="M28,25H24a1,1,0,1,1,0-2H27l0-9.72-8.31,6a1,1,0,0,1-1.23,0L8.19,12A1,1,0,0,1,8,10.56a1,1,0,0,1,1.43-.15l8.63,6.77,9.19-6.59a1.08,1.08,0,0,1,1.17-.16,1,1,0,0,1,.55.89L29,24a1,1,0,0,1-.29.71A1.06,1.06,0,0,1,28,25Z"/>
        <path
          d="M9.74,12.1a2.79,2.79,0,0,1-1.14-.21,1,1,0,0,1-.51-.9,1,1,0,0,1,1-1H27.8a1,1,0,0,1,0,2H10.41A1.86,1.86,0,0,1,9.74,12.1ZM10,11h.12a1.06,1.06,0,0,0-.12-.48Z"/>
      </g>
    ]
  }
  getViewBox = () => '0 0 36 36'
}
